"use client";

import Detail from "@/app/homepage/company/components/Detail";
import History from "@/app/homepage/company/components/History";
import BusinessField from "@/app/homepage/company/components/BusinessField";
import SocialContribution from "@/app/homepage/company/components/SocialContribution";
import Overview from "@/app/homepage/company/components/Overview";
import Vision from "@/app/homepage/company/components/Vision";
import LocationMap from "@/app/homepage/company/components/LocationMap"



const COMPONENT_COMPANY_MAP = {
    "detail": Detail,
    "history": History,
    "business-field": BusinessField,
    "social-contribution": SocialContribution,
    "overview": Overview,
    "vision": Vision,
    "location-map": LocationMap,
};

export default function ClientRenderer({ slug }) {
    const Component = COMPONENT_COMPANY_MAP[slug];
    if (!Component) return <div>해당 페이지가 없습니다.</div>;

    return <Component />;
}
